(function () {
    "use strict";


    function Page() {
        this.url = window.nadex.marketing.analytics.url;
    }

    /**
     * Formats the page name based on the url. This is fairly DFX specific so might need changing
     * @returns {*}
     */
    Page.prototype.getPageName = function (mockWindow) {
        /*
        var windowObject = mockWindow || window;
        var cleanPath = this.url.cleanPathForReporting(windowObject.location.pathname);
        var pageName;
        var domain = windowObject.location.hostname;
        
        
        if (this.url.isHomepage(cleanPath)) {
            //cleanPath = ':home-page'; //DFX usage
            cleanPath = ':root:home'; //Nadex usage
        }
        if (windowObject.nadex && windowObject.nadex.dfx && windowObject.nadex.dfx.pageName && windowObject.nadex.dfx.pageName.length > 0) {
            pageName = windowObject.nadex.dfx.pageName;
        } else if (this.url.isErrorPage(windowObject.document.title)) {
            pageName = '404 - page not found';
        } else {
            pageName = cleanPath;
        }
        */

        //nadex specific
        //to ensure tracking consistency, the below is taken from the legacy sitecat tracking code

        var pageName = "";
        var sectionName = "";
        var sectionAndPage = "";

        //look for page specific object containing details that should be passed to sitecat, generally used on IRPs
        if (typeof SiteCatPageInfo != "undefined") {

            //set the section and page name
            sectionAndPage = SiteCatPageInfo.section  + ":" + SiteCatPageInfo.pagename;
            //events are tracking in the iRP tracker plugin (see plugins directory)
            console.log("nadex analytics: inline page info found...", sectionAndPage);
        
        } else {

            console.log("nadex analytics: inline page info not found, using breadcrumbs...");

            var arrCrumbs = new Array();


            //remove reliance on jQuery
            //var listItems = jQuery(".breadcrumb").find("li");
            //listItems.each(function() {
            //    arrCrumbs.push(jQuery(this).text());
            //});

            //add vanilla JS
            var listItems = document.querySelectorAll('.breadcrumb li');
            Array.prototype.forEach.call(listItems, function(el, i){
                arrCrumbs.push(el.innerText)
            });                
           

            sectionName = arrCrumbs[1];

            for (var i = 2; i < arrCrumbs.length; i++) { //start at 2, skip "home" link from breadcrumb
                pageName += arrCrumbs[i] + ":";
            }
            if (pageName === "" && arrCrumbs[0] !== "Home") {
                pageName = "root:home"
                sectionName = "";
            }  
            if (sectionName === "What's Moving The Markets") {
                sectionName = "market news"
            }             

            sectionAndPage = sectionName + ":" + pageName;
            console.log("nadex analytics: sectionAndPage", sectionAndPage);

        } 

        return sectionAndPage.toLowerCase();       
    };



    window.nadex = window.nadex || {};
    window.nadex.marketing = window.nadex.marketing || {};
    window.nadex.marketing.analytics = window.nadex.marketing.analytics || {};
    window.nadex.marketing.analytics.page = new Page();

}());